import { AdvocateSendEmailMeta, AdvocateSendEmailPayload } from 'types/store/AdvocateSendEmail';
import { createAsyncReducer } from 'utils/Redux';

import { advocateSendEmailActions } from '../actions';

export default createAsyncReducer<AdvocateSendEmailMeta, AdvocateSendEmailPayload>(advocateSendEmailActions);
